import { ChangeDetectionStrategy, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';

import { Feature, FeatureNames, IsStringValueProperty } from '@vi-iot/client';

import { NO_VALUE } from '@pipes';
import {
  ActiveErrorsStore,
  AuthStore,
  DevicesStore,
  InstallationDetailsStore,
  InstallationFeaturesStore,
  InstallationHeaderTileTypeName,
  OwnerDetails,
  RichDevice,
  isEcoWaterDevice,
  isSolarLogInverter,
} from '@store';
import { takeUntil } from 'rxjs/operators';
import { BrandLogo } from 'src/app/+installations/helpers/brand-logo';

@Component({
  selector: 'app-device-tile-wrapper',
  templateUrl: './device-tile-wrapper.component.html',
  styleUrls: ['./device-tile-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceTileWrapperComponent implements OnInit, OnDestroy {
  @Input() device: RichDevice;

  readonly InstallationHeaderTileTypeName = InstallationHeaderTileTypeName;
  readonly NO_VALUE = NO_VALUE;

  tileTypeName: InstallationHeaderTileTypeName;
  owner: OwnerDetails;
  defaultTitleOfSolarLog: string;
  serial: string;
  deviceVariant$: Observable<Feature<IsStringValueProperty, never>>;
  deviceThirdpartyModel$: Observable<Feature<IsStringValueProperty, never>>;
  brandLogo: string;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public installationDetailsStore: InstallationDetailsStore,
    public activeErrorsStore: ActiveErrorsStore,
    public devicesStore: DevicesStore,
    public authStore: AuthStore,
    private translation: TranslateService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.installationDetailsStore.owner$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((ownerDetails) => {
        const heaterOf = this.translation.instant('+INSTALLATIONS.INSTALLATIONS.INSTALLATION_OF');
        this.defaultTitleOfSolarLog = `${heaterOf} ${ownerDetails.name}`;
      });

    this.setTileTypeName(this.device);
    const brandDetails = this.device?.roles;
    this.brandLogo = BrandLogo.getBrandLogo(brandDetails);
  }

  private setTileTypeName(device: RichDevice): void {
    if (isSolarLogInverter(device)) {
      this.getDeviceThirdpartyModel(device?.id, device?.gatewaySerial);
      this.tileTypeName = InstallationHeaderTileTypeName.SOLARLOG;
    } else if (isEcoWaterDevice(device)) {
      this.getDeviceVariant(device.id, device.gatewaySerial);
      this.tileTypeName = InstallationHeaderTileTypeName.ECO_WATER;
    } else {
      this.tileTypeName = InstallationHeaderTileTypeName.COMMON;
    }
  }

  private getDeviceThirdpartyModel(deviceId: string, gatewaySerial: string): void {
    this.deviceThirdpartyModel$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceThirdpartyModel,
      deviceId,
      gatewaySerial
    );
  }

  private getDeviceVariant(deviceId: string, gatewaySerial: string): void {
    this.deviceVariant$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceVariant,
      deviceId,
      gatewaySerial
    );
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
